<template>
  <div class="manual-tools02-contents">
    <el-row>
      <el-col>
        <h2>ASPとアドタスカルを連携する（AdCent）</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h4>
          【１】アドタスカルの「<router-link
            :to="`/tools02/${tool.codeKebab}/point-back`"
            >ASP自動連携設定</router-link
          >」にアクセスします。
        </h4>
        <img
          :src="`${rt}/img/manual/${tool.codeKebab}/general/point-back.png`"
          alt=""
        />
        <h4>【２】該当するASPの通知URLをコピーします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no08/no24/01.png`" alt="" />
        <h4>【３】以下の文言を担当者に連絡します。</h4>
        <p>
          -----------------------<br />
          アドタスカルのキックバック連携、希望です。<br />
          <br />
          キックバック通知URL：（【２】でコピーした通知URL）<br />
          -----------------------
        </p>
        <h4>【４】連携が完了すると、テスト案件用のURLが発行してもらえます。</h4>
        <h5>▼アフィリエイトリンク</h5>
        <p class="blue">https://stg-secure1.adcent.jp/link?_vl=●●●</p>
        <h5>▼クリックパラメータを自分で付ける</h5>
        <p class="blue">
          https://stg-secure1.adcent.jp/link?_vl=●●●<span class="green">&adc={{tool.clickIdName}}_xxx</span>
        </p>
        <p>※自分で付けたパラメータを覚えておきましょう</p>
        <h4>【５】パラメータを付けたURLを担当者へ連絡し、テストを行ってもらいます。</h4>
        <p>
          -----------------------<br />
          アドタスカルの連携テスト、希望です。<br />
          <br />
          アフィリエイトリンク：（【５】で作成したURL）<br />
          -----------------------
        </p>
        <h4>
          【６】アドタスカルの「<router-link
            :to="`/tools02/${tool.codeKebab}/auto-import-log`"
            >自動登録履歴</router-link
          >」を確認します。
        </h4>
        <img
          :src="`${rt}/img/manual/${tool.codeKebab}/general/log.png`"
          alt=""
        />

        <h4>
          【７】担当者からの連絡後に、テストCVが登録されていれば問題なく連携完了です。
        </h4>
        <AutoImportLog 
          :aspId="'32'"
          :conversionValue="'9000'"
        />
        <ul>
          <li>ASP：AdCent</li>
          <li>
            CV時間：テストした時間になっているか？（多少の誤差はあり）
          </li>
          <li>プログラム名：-</li>
          <li>パラメータ：【４】で付けたパラメータと一致しているか？</li>
          <li>プログラムID：プログラム情報登録で入力した値になっているか</li>
          <li>報酬額：0</li>
          <li>
            インポート状況：「CLICK IDが取得不可」のエラーがあっても大丈夫です。
          </li>
        </ul>

        <h4>【６】連携完了</h4>
        <p>担当さんに一報入れましょう。これで連携は完了です。</p>

        <PointbackSettingDescription :aspId="'32'" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PointbackSettingDescription from "@/components/Manual/Tools02/No08/Parts/PointbackSettingDescription.vue";
import AutoImportLog from "@/components/Manual/Tools02/No08/Parts/AutoImportLog.vue";

export default {
  name: "ManualGoogleCvContents",
  components: {
    PointbackSettingDescription,
    AutoImportLog,
  },
  props: {},
  computed: {
    ...mapGetters(["rt", "tool"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.blue {
  color: var(--blue);
}
.green {
  color: var(--green);
}
</style>
